import * as React from 'react';
import { AppContext } from '../../../AppContext';

export interface AgentToolInfo {
  name: string;
  description: string;
  requiresApproval?: boolean;
}

export function useAgentTools() {
  const {client} = React.useContext(AppContext);
  const [tools, setTools] = React.useState<AgentToolInfo[]>([]);

  React.useEffect(() => {
    void client<{event: string, data: object}, {success: boolean, value?: AgentToolInfo[]}>(
      {event: 'aiagents.getTools', data: {}},
    ).then((result) => {
      if (result.success && result.value) {
        setTools(result.value);
      }
    });
  }, [client]);

  return tools;
}
